<template>
  <NotificationComponent
    v-show="visible"
    :title="title"
    @close="handleCloseTruckNotification"
  >
    <ul
      v-if="Array.isArray(text)"
      class="list-disc pl-4"
    >
      <li
        v-for="(item, idx) in text"
        :key="idx"
        class="w-auto max-w-fit text-left text-sm font-normal text-steel-800"
      >
        {{ item }}
      </li>
    </ul>

    <p
      v-else
      class="text-left"
    >
      {{ text }}
    </p>
  </NotificationComponent>
</template>

<script setup>
import { useStore } from 'vuex';
import NotificationComponent from '../NotificationComponent.vue';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Trucks Posted',
  },
  text: {
    type: [Array, String],
    default: '',
  },
});

const store = useStore();

const handleCloseTruckNotification = () => {
  store.dispatch('toast/clearToasts');
};
</script>
